import { useState } from "react";
import { useHistory } from "react-router-dom";
import { MAKE_PUBLIC_PARAM } from "../../utils/urlParams";
export var useMakePublicGuard = function () {
    var push = useHistory().push;
    var _a = useState(null), pendingProductId = _a[0], setPendingProductId = _a[1];
    var requestMakePublic = function (product, onAllowed) {
        var _a;
        if (!product.publishingDate || product.publishingDate.trim() === "") {
            setPendingProductId((_a = product.id) !== null && _a !== void 0 ? _a : null);
            return;
        }
        onAllowed();
    };
    var closeGuard = function () { return setPendingProductId(null); };
    var goToEdit = function () {
        if (pendingProductId) {
            push("/bragency/products/edit/".concat(pendingProductId, "?").concat(MAKE_PUBLIC_PARAM, "=true"));
        }
        setPendingProductId(null);
    };
    return {
        requestMakePublic: requestMakePublic,
        isGuardOpen: pendingProductId !== null,
        closeGuard: closeGuard,
        goToEdit: goToEdit,
    };
};
